// extracted by mini-css-extract-plugin
export default {"header":"TotalExpensesFormHeader_header__lLK3O"};